<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12 px-1 mb-2">
                <div class="card">
                    <div class="card-header"><h4 class="mb-0 align-middle">Leaderboards</h4></div>

                    <div class="card-body">
                        <div ref="boards-table"></div>
                    </div>
                </div>
            </div>
            <div v-if="authUser" class="col-md-12 px-1 mb-2">
                <div class="card">
                    <div class="card-header"><h4 class="mb-0 align-middle">Create Group</h4></div>

                    <div class="card-body">
                        <form class="form-inline">
                                <div class="form-group mr-2">
                                    <label for="title" class="sr-only">Group Title</label>
                                    <input type="text" name="title" id="title" v-model="newGroup.title" placeholder="Group Title" class="form-control" :class="{'is-invalid': !valid}">
                                </div>
                                <div class="form-group mr-2">
                                    <label for="details" class="sr-only">Group Details</label>
                                    <input type="text" name="details" id="details" v-model="newGroup.description" placeholder="Group Details" class="form-control">
                                </div>
                                <div class="form-group mr-2">
                                    <label for="private" class="sr-only">Group Type</label>
                                    <div class="form-check form-check-inline">
                                        <input type="radio" class="form-check-input" name="private" id="inlineRadio1" value="0" v-model="newGroup.private">
                                        <label class="form-check-label" for="inlineRadio1">Public</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input type="radio" class="form-check-input" name="private" id="inlineRadio2" value="1" v-model="newGroup.private">
                                        <label class="form-check-label" for="inlineRadio2">Hidden</label>
                                    </div>
                                </div>
                                <button @click="createGroup" type="button" class="btn btn-primary">Add Group</button>
                            </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            groups: [],
            dataInterval: false,
            groupsTable: false,
            authUser: window.authUser || false,
            base: {
                title: null,
                description: null,
                private: 0,
            },
            newGroup: {
                title: null,
                description: null,
                private: 0,
            },
            valid: true,
            modal: window.modal,
        }
    },
    computed: {
        boards() {
            var boards = [];
            this.groups.forEach((group) => {
                if (group.boards.length) {
                    group.boards.forEach((board) => {
                        boards.push(board);
                    })
                } else {
                    let board = {
                        group_id: group.id,
                        group_title: group.title,
                    };
                    boards.push(board);
                }
            })

            return boards;
        }
    },
    methods: {
        getGroups(firstRun) {
            axios.get('/group')
                .then((result) => {
                    this.groups = result.data;

                    document.title = `The Extreme Airsoft - Scoreboard`;

                    if (firstRun) {
                        this.buildTable();
                    } else {
                        this.groupsTable.replaceData(this.boards);
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
        },
        buildTable() {
            let groups = this.groups.map((g) => {
                return g.title;
            })

            var columns = [
                    {
                        title: 'Board',
                        field: 'title',
                        cellClick:(e, cell) => {
                            this.$emit('board', cell.getRow().getData().id);
                        }
                    },
                    {
                        title: 'Details',
                        field: 'description',
                        cellClick:(e, cell) => {
                            this.$emit('board', cell.getRow().getData().id);
                        }
                    },
                ];

                if (this.authUser) {
                    columns.push({
                        title: "Delete",
                        field: "id",
                        width: 100,
                        hozAlign: "center",
                        formatter: (cell, formatterParams, onRendered) => {
                            return "<button type='button' class='btn btn-block btn-sm btn-danger'><i class='far fa-trash-alt'></i></button>";
                        },
                        cellClick:(e, cell) => {
                            console.log("Cell click:", cell.getRow().getData().id);
                            this.modal.title = "Delete Board";
                            this.modal.body = `Are you sure that you want to delete board  ${ cell.getRow().getData().title }  this can not be undone?`;
                            this.modal.confirm(() => {
                                axios.delete(`/board/delete/${cell.getRow().getData().id}`)
                                .then((response) => {
                                    console.log("Response:", response);
                                    this.getGroups();
                                })
                                .catch((e) => {
                                    console.error(e);
                                });
                            }, () => {
                                console.warn('Cancel Clicked');
                            });
                        }
                    });
                }

            this.groupsTable = new Tabulator(this.$refs['boards-table'], {
                layout: 'fitColumns',
                data: this.boards,
                groupBy: 'group_id',
                groupHeader:(value, count, data, group) => {
                    if (count) {
                        return data[0].group_title;
                    }
                    return '';
                },
                groupClick:(e, group) => {
                    let groupId = group.getRows()[0].getData().group_id;
                    this.$emit('group', groupId);
                },
                columns: columns,
                // rowClick:(e, row) => {
                //     let boardId = row.getData().id;
                //     console.log('Board ID:', boardId);
                //     this.$emit('board', boardId);
                // },
            });
        },
        validate() {
            console.log(this.newGroup);
            return (this.newGroup.title && this.newGroup.title.length);
        },
        createGroup() {
            this.valid = true;
            if (this.validate()) {
                axios.post('/group/add', this.newGroup)
                    .then((result) => {
                        this.reset();
                        this.$emit('group', result.data.id);
                    })
                    .catch((err) => {
                        console.error("Create Error:", err);
                    })
            } else {
                this.valid = false;
            }
        },
        reset() {
            this.newGroup = Object.assign({}, this.base);
        },
    },
    mounted() {
        this.getGroups(true);
        if (!this.dataInterval) {
            this.dataInterval = setInterval(this.getGroups.bind(this), 20 * 1000);
        }
    },
    beforeDestroy() {
        clearInterval(this.dataInterval);
    },
}
</script>